<template>
    <!--begin::Card-->
    <div class="card">
        <!--begin::Card header-->
        <div class="card-header border-0">
            <!--begin::Card title-->
            <div class="card-title">
                <svg
                    width="28"
                    height="28"
                    viewBox="0 0 28 28"
                    fill="none"
                    xmlns="http://www.w3.org/2000/svg"
                    style="margin-right: 17px"
                >
                    <path
                        d="M14.1283 17.9549L9.60164 22.4816C9.05358 23.0106 8.32164 23.3061 7.55997 23.3061C6.7983 23.3061 6.06636 23.0106 5.51831 22.4816C5.24951 22.2139 5.03623 21.8957 4.8907 21.5453C4.74517 21.195 4.67026 20.8193 4.67026 20.4399C4.67026 20.0606 4.74517 19.6849 4.8907 19.3346C5.03623 18.9842 5.24951 18.666 5.51831 18.3983L10.045 13.8716C10.2647 13.6519 10.3881 13.354 10.3881 13.0433C10.3881 12.7326 10.2647 12.4346 10.045 12.2149C9.82528 11.9953 9.52732 11.8718 9.21664 11.8718C8.90595 11.8718 8.60799 11.9953 8.38831 12.2149L3.86164 16.7533C2.94972 17.7459 2.45653 19.0524 2.48506 20.4C2.51359 21.7476 3.06163 23.0321 4.01474 23.9852C4.96785 24.9383 6.25233 25.4863 7.59993 25.5149C8.94753 25.5434 10.254 25.0502 11.2466 24.1383L15.785 19.6116C15.8938 19.5028 15.98 19.3737 16.0389 19.2316C16.0978 19.0894 16.1281 18.9371 16.1281 18.7833C16.1281 18.6294 16.0978 18.4771 16.0389 18.335C15.98 18.1929 15.8938 18.0637 15.785 17.9549C15.6762 17.8462 15.5471 17.7599 15.4049 17.701C15.2628 17.6421 15.1105 17.6118 14.9566 17.6118C14.8028 17.6118 14.6505 17.6421 14.5083 17.701C14.3662 17.7599 14.2371 17.8462 14.1283 17.9549ZM24.1383 3.86161C23.1569 2.88629 21.8294 2.33887 20.4458 2.33887C19.0622 2.33887 17.7347 2.88629 16.7533 3.86161L12.215 8.38828C12.1062 8.49706 12.0199 8.6262 11.961 8.76832C11.9022 8.91045 11.8719 9.06278 11.8719 9.21661C11.8719 9.37045 11.9022 9.52278 11.961 9.6649C12.0199 9.80703 12.1062 9.93617 12.215 10.0449C12.3238 10.1537 12.4529 10.24 12.595 10.2989C12.7371 10.3578 12.8895 10.3881 13.0433 10.3881C13.1971 10.3881 13.3495 10.3578 13.4916 10.2989C13.6337 10.24 13.7629 10.1537 13.8716 10.0449L18.3983 5.51828C18.9464 4.98934 19.6783 4.69375 20.44 4.69375C21.2016 4.69375 21.9336 4.98934 22.4816 5.51828C22.7504 5.78602 22.9637 6.10419 23.1092 6.45455C23.2548 6.80491 23.3297 7.18056 23.3297 7.55995C23.3297 7.93933 23.2548 8.31498 23.1092 8.66534C22.9637 9.0157 22.7504 9.33388 22.4816 9.60161L17.955 14.1283C17.8456 14.2367 17.7588 14.3658 17.6996 14.5079C17.6404 14.6501 17.6099 14.8026 17.6099 14.9566C17.6099 15.1106 17.6404 15.2631 17.6996 15.4053C17.7588 15.5475 17.8456 15.6765 17.955 15.7849C18.0634 15.8943 18.1925 15.9811 18.3346 16.0403C18.4768 16.0996 18.6293 16.13 18.7833 16.13C18.9373 16.13 19.0898 16.0996 19.232 16.0403C19.3741 15.9811 19.5032 15.8943 19.6116 15.7849L24.1383 11.2466C25.1136 10.2652 25.6611 8.93775 25.6611 7.55411C25.6611 6.17048 25.1136 4.84304 24.1383 3.86161ZM10.3016 17.6983C10.4107 17.8064 10.5399 17.892 10.6821 17.95C10.8242 18.0081 10.9764 18.0375 11.13 18.0366C11.2835 18.0375 11.4357 18.0081 11.5779 17.95C11.72 17.892 11.8493 17.8064 11.9583 17.6983L17.6983 11.9583C17.918 11.7386 18.0414 11.4406 18.0414 11.1299C18.0414 10.8193 17.918 10.5213 17.6983 10.3016C17.4786 10.0819 17.1807 9.95851 16.87 9.95851C16.5593 9.95851 16.2613 10.0819 16.0416 10.3016L10.3016 16.0416C10.1923 16.1501 10.1055 16.2791 10.0463 16.4213C9.98704 16.5634 9.95654 16.7159 9.95654 16.8699C9.95654 17.024 9.98704 17.1765 10.0463 17.3186C10.1055 17.4608 10.1923 17.5898 10.3016 17.6983Z"
                        fill="#006C90"
                    />
                </svg>
                Registrar Links
            </div>
            <!--begin::Card title-->
        </div>
        <!--end::Card header-->

        <!--begin: Card-body Drag and Drop-->
        <div class="card-body col-12">
            <div id="card-filter" class="col-12 row">
                <div class="col-12 col-md-6 col-xl-6 col-xxl-6">
                    <label for="" class="col-12">Nombre</label>
                    <input
                        type="text"
                        class="col-12 form-control"
                        v-model="nombreLink"
                    />
                </div>
                <div class="col-12 col-md-6 col-xl-6 col-xxl-6">
                    <label for="" class="col-12">Link</label>
                    <input
                        type="text"
                        class="col-12 form-control"
                        v-model="link"
                    />
                </div>
                <div class="col-12 col-md-6 col-xl-6 col-xxl-6">
                    <label for="" class="col-12">Descripción </label>
                    <input
                        type="text"
                        class="col-12 form-control"
                        v-model="descripcionLink"
                    />
                </div>
                <div class="col-12 col-md-6 col-xl-6 col-xxl-6">
                    <label for="" class="col-12">Grupo </label>
                    <select
                        class="form-select"
                        id="grupo"
                        v-model="selectedGroup"
                    >
                        <option
                            v-for="group in groups"
                            :key="group.id"
                            :value="group.Id"
                        >
                            {{ group.Nombre }}
                        </option>
                    </select>
                </div>

                <div class="d-flex justify-content-end col-12">
                    <button
                        class="btn btn-melon mt-4"
                        @click="agregarItem"
                    >
                        Agregar
                    </button>
                </div>
            </div>
            <div id="button-eliminar">
                <button @click="eliminarFilas" class="btn btn-melon-secundario">
                    Eliminar
                </button>
            </div>

            <div class="contenedor-table">
                <table class="table table-striped">
                    <thead class="thead-document">
                        <tr>
                            <th scope="col col-2" class="th-1">
                                <input
                                    type="checkbox"
                                    id="header-checkbox"
                                    v-model="selectAll"
                                />
                            </th>
                            <th scope="col" class="">Nombre</th>
                            <th scope="col" class="">Link</th>
                            <th scope="col" class="">Descripción</th>
                            <th scope="col" class="">Fecha Carga</th>
                            <th scope="col" class="">Grupo</th>
                            <th scope="col" class="th-6"></th>
                        </tr>
                    </thead>
                    <tbody>
                        <tr v-if="items.length == 0" class="text-center">
                            <th colspan="6">No hay archivos cargados</th>
                        </tr>
                        <tr v-for="(item, index) in items" :key="index">
                            <th scope="col" class="th-1">
                                <input
                                    type="checkbox"
                                    :id="'checkbox' + index"
                                    v-model="item.selected"
                                />
                            </th>
                            <th scope="col">{{ item.nombreLink }}</th>
                            <th scope="col">{{ item.Link  }}</th>
                            <th scope="col">{{ item.descripcionLink}}</th>
                            <th scope="col">{{ item.date }}</th>
                            <th scope="col">{{ item.group }}</th>
                            <th
                                scope="col"
                                style="cursor: pointer; position: relative"
                                @click="mostrarEdit(index)"
                            >
                                <svg
                                    xmlns="http://www.w3.org/2000/svg"
                                    width="20"
                                    height="7"
                                    viewBox="0 0 27 8"
                                    fill="none"
                                >
                                    <path
                                        d="M19.5 4C19.5 5.933 21.067 7.5 23 7.5C24.933 7.5 26.5 5.933 26.5 4C26.5 2.067 24.933 0.5 23 0.5C21.067 0.5 19.5 2.067 19.5 4Z"
                                        fill="#99ABB4"
                                    />
                                    <path
                                        d="M10.1667 4C10.1667 5.933 11.7338 7.5 13.6667 7.5C15.5997 7.5 17.1667 5.933 17.1667 4C17.1667 2.067 15.5997 0.5 13.6667 0.5C11.7338 0.5 10.1667 2.067 10.1667 4Z"
                                        fill="#99ABB4"
                                    />
                                    <path
                                        d="M0.5 4C0.5 5.933 2.067 7.5 4 7.5C5.933 7.5 7.5 5.933 7.5 4C7.5 2.067 5.933 0.5 4 0.5C2.067 0.5 0.5 2.067 0.5 4Z"
                                        fill="#99ABB4"
                                    />
                                </svg>
                                <div v-if="item.edit" class="editar-box">
                                    <ul>
                                        <li @click="modalEdit(index, item)">
                                            Asignar grupos
                                        </li>
                                    </ul>
                                </div>
                            </th>
                        </tr>
                    </tbody>
                </table>
            </div>
            <div id="button-guardar">
                <button @click="guardarLinks">Guardar</button>
            </div>
            <!--end: Drag and Drop-->

            <!--Modal Grupo-->
            <transition name="fade">
                <div class="modal-overlay" v-if="showModalEdit">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <p class="modal-title" id="exampleModalLabel">
                                    Asignar grupo
                                </p>
                                <button
                                    type="button"
                                    class="closeModel"
                                    data-dismiss="modal"
                                    aria-label="Cerrar"
                                    @click="showModalEdit = false"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="30"
                                        height="30"
                                        viewBox="0 0 30 30"
                                        fill="none"
                                    >
                                        <circle
                                            cx="15"
                                            cy="15"
                                            r="15"
                                            fill="#006C90"
                                        />
                                        <path
                                            d="M21 8.97714L19.7914 7.5L15 13.3562L10.2086 7.5L9 8.97714L13.7914 14.8333L9 20.6895L10.2086 22.1667L15 16.3105L19.7914 22.1667L21 20.6895L16.2086 14.8333L21 8.97714Z"
                                            fill="white"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <div class="modal-body">
                                <label class="title-body" for="grupo"
                                    >Elegir el grupo:</label
                                ><br />
                                <select
                                    class="form-select"
                                    id="grupo"
                                    v-model="selectedGroup"
                                >
                                    <option
                                        v-for="group in groups"
                                        :key="group.id"
                                        :value="group.Id"
                                    >
                                        {{ group.Nombre }}
                                    </option>
                                </select>
                            </div>
                            <div class="modal-footer">
                                <button
                                    type="button"
                                    class="btn btn-guardar"
                                    @click="asignarGrupo()"
                                >
                                    Guardar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

            <!--Modal Exito-->
            <transition name="fade">
                <div class="modal-overlay" v-if="showModalExito">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <p class="modal-title" id="exampleModalLabel">
                                    Carga de Links
                                </p>
                                <button
                                    type="button"
                                    class="closeModel"
                                    data-dismiss="modal"
                                    aria-label="Cerrar"
                                    @click="showModalExito = false"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="30"
                                        height="30"
                                        viewBox="0 0 30 30"
                                        fill="none"
                                    >
                                        <circle
                                            cx="15"
                                            cy="15"
                                            r="15"
                                            fill="#006C90"
                                        />
                                        <path
                                            d="M21 8.97714L19.7914 7.5L15 13.3562L10.2086 7.5L9 8.97714L13.7914 14.8333L9 20.6895L10.2086 22.1667L15 16.3105L19.7914 22.1667L21 20.6895L16.2086 14.8333L21 8.97714Z"
                                            fill="white"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <div class="modal-body">
                                <p>Los links se actualizaron correctamente.</p>
                            </div>
                            <div class="modal-footer">
                                <button
                                    type="button"
                                    class="btn btn-guardar"
                                    @click="showModalExito = false"
                                >
                                    Aceptar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>

            <!--Modal Error-->
            <transition name="fade">
                <div class="modal-overlay" v-if="showModalError">
                    <div class="modal-dialog" role="document">
                        <div class="modal-content">
                            <div class="modal-header">
                                <p
                                    class="modal-title header-error"
                                    id="exampleModalLabel"
                                >
                                    ERROR
                                </p>
                                <button
                                    type="button"
                                    class="closeModel"
                                    data-dismiss="modal"
                                    aria-label="Cerrar"
                                    @click="showModalError = false"
                                >
                                    <svg
                                        xmlns="http://www.w3.org/2000/svg"
                                        width="30"
                                        height="30"
                                        viewBox="0 0 30 30"
                                        fill="none"
                                    >
                                        <circle
                                            cx="15"
                                            cy="15"
                                            r="15"
                                            fill="#006C90"
                                        />
                                        <path
                                            d="M21 8.97714L19.7914 7.5L15 13.3562L10.2086 7.5L9 8.97714L13.7914 14.8333L9 20.6895L10.2086 22.1667L15 16.3105L19.7914 22.1667L21 20.6895L16.2086 14.8333L21 8.97714Z"
                                            fill="white"
                                        />
                                    </svg>
                                </button>
                            </div>
                            <div class="modal-body">
                                <p>Error al cargar los links.</p>
                            </div>
                            <div class="modal-footer">
                                <button
                                    type="button"
                                    class="btn btn-error"
                                    @click="showModalError = false"
                                >
                                    Aceptar
                                </button>
                            </div>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <!--end::Card body-->
        <Loading v-if="loading"></Loading>
    </div>
    <!--end::Card-->
</template>

<script>
import { Actions } from "@/store/enums/StoreEnums";
import { ref } from "vue";
import { useStore } from "vuex";
import Loading from "@/components/Loading.vue";
import Swal from "sweetalert2/dist/sweetalert2.min.js";
export default {
    name: "Documents",
    components: {
        Loading,
    },
    data() {
        const fechaActual = new Date();
        const dia = fechaActual.getDate();
        const mes = fechaActual.getMonth() + 1;
        const año = fechaActual.getFullYear();
        const nombre = ref("");

        const store = useStore();

        const nombreLink = ref("");
        const link = ref("");
        const descripcionLink = ref("");

        return {
            selectAll: false,
            items: [],
            fecha: `${dia}/${mes}/${año}`,
            nombre,
            link,
            nombreLink,
            descripcionLink,
            selectedGroup: null,
            showModalEdit: false,
            store,
            loading: false,
            showModalExito: false,
            showModalError: false,
        };
    },
    watch: {
        selectAll: function (value) {
            this.items.forEach((item) => {
                item.selected = value;
            });
        },
    },
    methods: {
        modalEdit(index) {
            this.showModalEdit = true;
            this.indexEdit = index;
            this.selectedGroup = this.items[index].grupoId;
        },
        eliminarFilas() {
            this.items = this.items.filter((item) => !item.selected);
        },
        mostrarEdit(index) {
            if (!this.items[index].edit) {
                this.items.forEach((item) => {
                    item.edit = false;
                });
            }
            this.items[index].edit = !this.items[index].edit;
        },
        agregarItem() {
            const nombreInput = this.nombreLink;
            const linkInput = this.link;
            const descripcionLink = this.descripcionLink;
            const selectedGroup = this.selectedGroup;

            if (nombreInput && linkInput && descripcionLink && selectedGroup) {
                const newItem = {
                    nombreLink: nombreInput,
                    descripcionLink: descripcionLink,
                    date: this.fecha,
                    group: this.groups.filter(
                        (group) => group.Id == selectedGroup
                    )[0].Nombre,
                    grupoId: selectedGroup,
                    selected: false,
                    edit: false,
                    Link: linkInput,
                };

                this.items.push(newItem);

                this.nombreLink = null;
                this.link = null;
                this.descripcionLink = null;
            } else {
                Swal.fire({
                    text: "Debe ingresar todos los campos",
                    icon: "error",
                    buttonsStyling: false,
                    confirmButtonText: "Intentar Nuevamente",
                    customClass: {
                        confirmButton: "btn btn-melon",
                    },
                });
            }
        },
        asignarGrupo() {
            this.items[this.indexEdit].grupoId = this.selectedGroup;
            for (var i = 0; i < this.groups.length; i++) {
                if (this.groups[i].Id == this.selectedGroup) {
                    this.items[this.indexEdit].group = this.groups[i].Nombre;
                }
            }
            this.showModalEdit = false;
        },
        async guardarLinks() {
            if (this.items.length > 0) {
                this.loading = true;
                const values = this.items.map((proxy) => {
                    return { ...proxy };
                });

                var formData = new FormData();
                formData.append("links", JSON.stringify(values));

                try {
                    const data = await this.store.dispatch(
                        Actions.CREATE_LINKS,
                        formData
                    );
                    this.showModalExito = true;
                    this.items = [];
                    this.loading = false;
                } catch (error) {
                    console.log(error);
                    this.loading = false;
                    this.showModalError = true;
                }
            }
        },
    },
    setup() {
        const store = useStore();
        const groups = ref([]);

        const fetchGroups = async () => {
            try {
                const data = await store.dispatch(Actions.GET_GROUPS);
                groups.value = data;
            } catch (error) {
                console.error(error);
            }
        };

        fetchGroups();

        return {
            groups,
        };
    },
};
</script>
<style scoped>
.contenedor-table {
    overflow-x: auto;
    white-space: nowrap;
}

.modal-dialog {
    width: 35rem;
}

.closeModel {
    border: 0px;
    background-color: #fff;
}

.selectGroup {
    border-radius: 50px;
    border: 1px solid #cecece;
    background: #fff;
    width: 100%;
    height: 35px;
}

.btn-guardar {
    display: flex;
    width: 120px;
    height: 27px;
    padding: 5px 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    border-radius: 10px;
    border: 1px solid #006c90;
    background: #006c90;
    color: #fff;
    text-align: center;
    font-size: 14px;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.modal-footer {
    padding: 0px 1.5rem 1.5rem 0px !important;
    border: 0px !important;
}

.link {
    width: 50%;
}

.nombre {
    width: 30%;
}

#card-filter {
    background-color: #fff;
    width: 100%;
    height: auto;
    border-radius: 10px;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
    padding-top: 13px;
    padding-left: 18px;
    padding-bottom: 9px;
}

#card-filter label {
    color: #006c90;
    font-size: 1rem;
    font-style: normal;
    font-weight: 600;
    line-height: normal;
}

/* #card-filter input {
  border-radius: 30px;
  border: 1px solid #bdbdbd;
  padding-left: 10px;
  font-size: 1rem;
  color: gray;
} */

.button-limpiar {
    border-radius: 10px;
    background: #99abb4;
    color: #fff;
    text-align: center;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
    border: 0px;
}

#button-eliminar {
    filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
    padding-top: 67px;
    display: inline-flex;
    justify-content: end;
    width: 100%;
}

#button-guardar {
    filter: drop-shadow(0px 0px 4px rgba(0, 0, 0, 0.25));
    padding-top: 38px;
    display: inline-flex;
    justify-content: end;
    width: 100%;
}

#button-eliminar button,
#button-guardar button {
    border-radius: 10px;
    border: 1px solid #006c90;
    background: #006c90;
    display: flex;
    width: 120px;
    height: 27px;
    padding: 5px 10px;
    justify-content: center;
    align-items: center;
    gap: 10px;
    flex-shrink: 0;
    color: #fff;
    text-align: center;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.table {
    margin-top: 22px;
    width: 100%;
    flex-shrink: 0;
    border-radius: 10px 10px 10px 10px;
    background: #fff;
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
}

.thead-document {
    border-radius: 10px 10px 0px 0px;
    width: 100%;
    height: 40px;
    flex-shrink: 0;
}

.thead-document th {
    background: #006c90;
    color: #fff;
    font-size: 1rem;
    font-style: normal;
    font-weight: 700;
    line-height: normal;
}

.th-1 {
    border-radius: 10px 0px 0px 0px;
    display: flex;
    justify-content: center;
    min-width: 4rem;
}

.th-2 {
    min-width: 10rem;
}

.th-3 {
    min-width: 15rem;
}

.th-4 {
    min-width: 8.75rem;
}

.th-5 {
    min-width: 5rem;
}

.th-6 {
    min-width: 4rem;
    border-radius: 0px 10px 0px 0px;
}

.card {
    background-color: rgba(243, 245, 246, 1);
}

.mr-2 {
    margin-right: 0.5rem !important;
}

.flex {
    display: -webkit-box !important;
    display: -ms-flexbox !important;
    display: flex !important;
}

.justify-content-end {
    -webkit-box-pack: end !important;
    -ms-flex-pack: end !important;
    justify-content: flex-end !important;
}

.customer-badge {
    border-radius: 2px;
    padding: 0.25em 0.5rem;
    text-transform: uppercase;
    font-weight: 700;
    font-size: 12px;
    letter-spacing: 0.3px;
}

.customer-badge.status-true {
    background-color: #c8e6c9;
    color: #256029;
}

.customer-badge.status-1 {
    background-color: #ffd8b2;
    color: #805b36;
}

.customer-badge.status-false {
    background-color: #ffcdd2;
    color: #c63737;
}

/* tbody tr th {
    color: #99abb4 !important;
    font-size: 0.88rem;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
} */

.button-edit {
    width: 100%;
    height: 30px;
    flex-shrink: 0;
    border-radius: 10px;
    background: #fff;
    border-color: rgba(0, 0, 0, 0.25);
    box-shadow: 0px 0px 4px 0px rgba(0, 0, 0, 0.25);
    color: #99abb4;
    font-size: 0.9rem;
    font-style: normal;
    font-weight: 500;
    line-height: normal;
    display: flex;
    align-items: center;
    justify-content: center;
}

.button-edit:hover {
    background: #006c90;
    color: white;
}
</style>
